import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class DashboardService {

    private lastOffersUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingoffer/latest-booked-by-user/`;
    private lastRequestsUrlDesc = `${environment.backendRoot}/webresources/frontend/entity.bookingrequest/latest-active-by-userDesc/`;
    private lastRequestsUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingrequest/latest-active-by-user/`;
    private allActiveRequestsUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingrequest/all-active-by-user/`;
    private allActiveOffersUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingoffer/findTotalOffersForUserId/`;
    private allPastBookingsUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingoffer/all-past-booked-by-user/`;
    private allActiveBookingUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingoffer/all-active-booked-by-user/`;
    private allCancelledBookingsUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingoffer/cancelled-by-user/`;
    private userUrl = `${environment.backendRoot}/webresources/frontend/entity.users/profile/`;
    private creaditCardUrl = `${environment.backendRoot}/webresources/frontend/entity.servicedata/`;
    private unreadUrl = `${environment.backendRoot}/webresources/frontend/entity.messagethread/user/unread/`;
    private chatroomUrl = `${environment.backendRoot}/webresources/frontend/entity.messagethread/user/`;
    private sendMessageUrl = `${environment.backendRoot}/webresources/frontend/entity.messagethread/msg/`;
    private deleteThreadUrl = `${environment.backendRoot}/webresources/frontend/entity.messagethread/`;
    private bookingFeesUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingoffer/cancellation-fees/`;
    private cancellationBookingUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingoffer/cancel/`;
    private removeREquestUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingrequest/expiry-date/`;
    private userEmailConfirmUrl = `${environment.backendRoot}/webresources/frontend/entity.users/sendConfirmationEmail/`;
    private removeBookingUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingoffer/removebooking/`;

    constructor(private http: HttpClient) { }


    getLastBookedByUser(userId: number, amount: number): Observable<any> {
        const url = this.lastOffersUrl + userId + '/' + amount;
        return this.http.get(url,
            {
                headers: new HttpHeaders()
                    .set('Content-Type', 'application/json')
            }
        );
    }

    removeBooking(bookingid: number): Observable<any> {
        const url = this.removeBookingUrl + bookingid;
        return this.http.get(url,
            {
                headers: new HttpHeaders()
                    .set('Content-Type', 'application/json')
            }
        );
    }

    getLastRequestsByUserDesc(userId: number, amount: number): Observable<any> {
        const url = this.lastRequestsUrlDesc + userId + '/' + amount;
        return this.http.get(url,
            {
                headers: new HttpHeaders()
                    .set('Content-Type', 'application/json')
            }
        );
    }

    getLastRequestsByUser(userId: number, amount: number): Observable<any> {
        const url = this.lastRequestsUrl + userId + '/' + amount;
        return this.http.get(url,
            { headers: new HttpHeaders().set('Content-Type', 'application/json') }
        );
    }

    getAllActiveRequestsByUser(userId: number): Observable<any> {
        const url = this.allActiveRequestsUrl + userId;
        return this.http.get(url,
            { headers: new HttpHeaders().set('Content-Type', 'application/json') }
        );
    }

    getAllActiveOffersByUser(userId: number): Observable<any> {
        const url = this.allActiveOffersUrl + userId;
        return this.http.get(url,
            { headers: new HttpHeaders().set('Content-Type', 'application/json') }
        );
    }

    getAllActiveBookingsByUser(userId: number): Observable<any> {
        const url = this.allActiveBookingUrl + userId;
        return this.http.get(url,
            { headers: new HttpHeaders().set('Content-Type', 'application/json') }
        );
    }

    getAllPastBookingsByUser(userId: number): Observable<any> {
        const url = this.allPastBookingsUrl + userId;
        return this.http.get(url,
            { headers: new HttpHeaders().set('Content-Type', 'application/json') }
        );
    }

    getAllCancelledBookingsByUser(userId: number): Observable<any> {
        const url = this.allCancelledBookingsUrl + userId;
        return this.http.get(url,
            { headers: new HttpHeaders().set('Content-Type', 'application/json') }
        );
    }

    getUser(userId: number): Observable<any> {
        const url = this.userUrl + userId;
        return this.http.get(url,
            { headers: new HttpHeaders().set('Content-Type', 'application/json') }
        );
    }

    changeUserInformation(userId: number, userInfo): Observable<any> {
        const url = this.userUrl + userId;
        const data = JSON.stringify(userInfo);
        return this.http.put(url, data,
            { headers: new HttpHeaders().set('Content-Type', 'application/json') }
        );
    }

    changeCreditCardInfo(userId, cardInfo) {
        const url = this.creaditCardUrl + userId;
        const data = JSON.stringify(cardInfo);
        return this.http.put(url, data,
            { headers: new HttpHeaders().set('Content-Type', 'application/json') }
        );
    }

    getUsersUnread(userId) {
        const url = this.unreadUrl + userId;
        return this.http.get(url,
            { headers: new HttpHeaders().set('Content-Type', 'application/json') }
        );
    }

    getUsersMessages(userId): Observable<any> {
        const url = this.chatroomUrl + userId;
        return this.http.get(url,
            { headers: new HttpHeaders().set('Content-Type', 'application/json') }
        );
    }

    sendMessage(threadId, message): Observable<any> {
        const url = this.sendMessageUrl + threadId;
        const data = JSON.stringify(message);
        return this.http.put(url, data,
            { headers: new HttpHeaders().set('Content-Type', 'application/json') }
        );
    }

    deleteThread(threadId): Observable<any> {
        const url = this.deleteThreadUrl + threadId;
        return this.http.delete(url,
            { headers: new HttpHeaders().set('Content-Type', 'application/json') }
        );
    }

    getBookingFees(bookingId): Observable<any> {
        const url = this.bookingFeesUrl + bookingId;
        return this.http.get(url,
            { headers: new HttpHeaders().set('Content-Type', 'application/json') }
        );
    }

    cancelBooking(bookingId, cancelationFeesId): Observable<any> {
        const url = this.cancellationBookingUrl + bookingId + '/' + cancelationFeesId;
        return this.http.get(url,
            { headers: new HttpHeaders().set('Content-Type', 'application/json') }
        );
    }

    removeRequest(id): Observable<any> {
        const date = new Date(2017).getTime();
        const url = this.removeREquestUrl + id + '/' + date;
        return this.http.put(url,
            { headers: new HttpHeaders().set('Content-Type', 'application/json') }
        );
    }

    sendUserEmailConfirm(userId): Observable<any> {
        const url = this.userEmailConfirmUrl + userId;
        return this.http.get(url,
            { headers: new HttpHeaders().set('Content-Type', 'text/plain') }
        );
    }


}
